var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mask-from-right relative inline-block",class:[
    _vm.$data.class,
    _vm.$data.staticClass,
    {
      'flex-1 group-hover:text-white inline-block leading-normal ml-2 max-sm:mb-px py-px sm:font-light text-accent focus-within:text-white ': _vm.primary,
    } ]},[(_vm.hideInput)?_c('span',{staticClass:" truncate whitespace-pre overflow-hidden r l absolute opacity-0 ",class:[
      'transition-opacity-color-fill-bgcolor',
      {
        'opacity-100': _vm.value,
      },
      _vm.inputClasses ],staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.value))]):_vm._e(),_c('base-field',_vm._b({class:[
      { inactive: _vm.hideInput },
      _vm.inputClasses,
      { 'cursor-default pointer-events-none': _vm.readonly } ],attrs:{"focus":_vm.focus,"readonly":_vm.readonly,"aria-readonly":_vm.readonly,"type":_vm.type,"value":_vm.value},on:{"input":function (value) { return _vm.$emit('input', value); }},nativeOn:{"blur":function($event){_vm.active = false},"focus":function($event){_vm.active = true}}},'base-field',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }